import React, { useState } from 'react';
import {
    Box,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

const About = () => {
    const [dialogOpen, setDialogOpen] = useState(null); // 'privacy' oder 'impressum'

    const dialogContent = {
        privacy: (
            <>
                <DialogTitle>Datenschutzerklärung</DialogTitle>
                <DialogContent>
                    <Typography>
                        In dieser Anwendung werden ausschließlich Daten gespeichert, die der Nutzer selbst und freiwillig angibt. Dazu gehören insbesondere:
                        E-Mail-Adresse und Passwort zur Erstellung eines Nutzerkontos, die Angaben zu Arenen (Standorte) und Informationen zu gefangenen Pokémon, die der Nutzer einträgt.
                        Einige dieser Informationen können für andere Nutzer sichtbar sein.
                        Die Daten werden nicht an Dritte weitergegeben und ausschließlich zum Zweck der Nutzung der App gespeichert.
                        Der Nutzer kann jederzeit die Löschung seines Accounts und aller gespeicherten Daten beantragen.
                    </Typography>
                </DialogContent>
            </>
        ),
        impressum: (
            <>
                <DialogTitle>Impressum</DialogTitle>
                <DialogContent>
                    <Typography variant="h6" gutterBottom>Angaben gemäß § 5 TMG</Typography>
                    <Typography>Daniel Hörenkamp</Typography>
                    <Typography>Kreuzstraße 69</Typography>
                    <Typography>44575 Castrop-Rauxel</Typography>
                    <Typography variant="h6" gutterBottom style={{ marginTop: '16px' }}>Kontakt:</Typography>
                    <Typography>E-Mail: d.hoerenkamp@gmail.com</Typography>
                    <Typography variant="h6" gutterBottom style={{ marginTop: '16px' }}>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</Typography>
                    <Typography>Daniel Hörenkamp</Typography>
                    <Typography>Kreuzstraße 69</Typography>
                    <Typography>44575 Castrop-Rauxel</Typography>
                </DialogContent>
            </>
        ),
    };

    return (
        <Box sx={{ padding: 3 }}>
            <Typography variant="h4" gutterBottom>
                Über diese App
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: 4 }}>
                Hier findest du Informationen zur App, zum Datenschutz und das Impressum.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <Button
                    variant="outlined"
                    onClick={() => setDialogOpen('privacy')}
                >
                    Datenschutzerklärung
                </Button>
                <Button
                    variant="outlined"
                    onClick={() => setDialogOpen('impressum')}
                >
                    Impressum
                </Button>
            </Box>

            <Dialog open={dialogOpen !== null} onClose={() => setDialogOpen(null)}>
                {dialogOpen && dialogContent[dialogOpen]}
                <DialogActions>
                    <Button onClick={() => setDialogOpen(null)} color="primary">
                        Schließen
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default About;